<template>
  <bita-modal
    id="comment-form-modal"
    title="ویرایش نظر"
    :is-loading="isLoading"
    @close="reset"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-select
              name="score"
              label="امتیاز (۱ تا ۵)"
              :validation-container-class="col6"
              :data-source="[
                { name: '۱ ستاره', id: '1' },
                { name: '۲ ستاره', id: '2' },
                { name: '۳ ستاره', id: '3' },
                { name: '۴ ستاره', id: '4' },
                { name: '۵ ستاره', id: '5' },
              ]"
              data-text-field="name"
              data-value-field="id"
              v-model="form.score"
            />
            
            <div class="col-lg-6 mb-3 d-flex align-items-center">
              <div class="custom-control custom-switch mt-4">
                <input type="checkbox" class="custom-control-input" id="is_like_switch" v-model="form.is_like">
                <label class="custom-control-label" for="is_like_switch">پیشنهاد می‌کنم (لایک)</label>
              </div>
            </div>

            <bita-textarea
              name="comment"
              label="متن نظر"
              rules="required"
              :validation-container-class="col12"
              v-model="form.comment"
              rows="4"
            />
          </div>
        </div>
      </bita-form>
    </div>

    <div slot="footer">
      <bita-bootbutton
        type="primary"
        title="ذخیره تغییرات"
        icon="fas fa-save"
        btn-width="120px"
        @click.native="save"
      />
    </div>
  </bita-modal>
</template>

<script>
export default {
  props: {
    isLoading: Boolean,
  },
  data() {
    return {
      col6: "col-lg-6",
      col12: "col-lg-12",
      form: {
        id: null,
        score: null,
        is_like: false,
        comment: "",
      },
    };
  },
  methods: {
    init(data) {
      this.form.id = data.id;
      this.form.score = data.score;
      this.form.is_like = data.is_like;
      this.form.comment = data.comment;
    },
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-save", this.form);
        }
      });
    },
    reset() {
      this.form = { id: null, score: null, is_like: false, comment: "" };
      this.$refs.form.reset();
    },
  },
};
</script>
